import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { countStaffs } from 'api/Attendance';
import { ruleInfoListFn, ruleAddFn, ruleEditFn, getSettingCycleFn as _getSettingCycleFn, showConversionRateInput } from 'api/approval/config';
import Org from '@/components/organization';
var dedaultDataForm = {
  is_all: '1',
  // 适用范围 1，2
  less_days: 0,
  // 新员工请假入职时间不能小于
  staff_ids: [],
  // 人员列表
  staffs: [],
  // 员工组
  mark: '',
  // 备注
  department_ids: [],
  // 部门列表
  deps: [],
  // 部门组
  id: null,
  name_en: '',
  // 假期名称（英文）
  name_zh: '',
  // 假期名称（中文）
  name_th: '',
  // 假期名称（泰文）
  is_setting: false,
  // 是否配置余额 余额设置
  my_is_setting: false,
  is_hire: '3',
  // 是否按入职时间 比例 分配额度, 等比例发放默认为3，全额发放
  release_type: null,
  // 逐日发放
  my_release_type: false,
  // 逐日发放复选框
  expire_time: '1',
  // 有效期
  days: 7,
  // 发放天数
  max_days: 7,
  // 最大天数
  rule: '1',
  // typeof string
  is_paid: '1',
  // 计薪规则
  paid_days: null,
  // 部分计薪天数
  prolong: null,
  // 延长有效期 单位月 如果没有 传0
  prolong_days: null,
  // 延长有效期 单位天 如果没有 传0
  cycle: 1,
  // 默认 一年发放, typeof number
  is_new_staff: false,
  // 新员工（勾选框）
  is_probation: false,
  // 通过试用期（勾选框）
  hour_to_day: 8,
  // 小时转天数计算单位/当time_type=0 ,必须存在
  time_type: '2',
  // 请假单位 0小时 1半天 2全天
  release_time: '01-01',
  // 每年发放时间
  release_month: 0,
  // 每年发放时间--月 需为number类型
  release_day: 0,
  // 每年发放时间--日 需为number类型
  my_incremental_rule: [{
    get: 0,
    lt: 1,
    days: null
  }, {
    get: 1,
    lt: null,
    days: null
  }],
  incremental_rule: '',
  // 司龄递增规则
  count_rule: '1' // 请假时长核算
};

// 额度规则选项
var QuotaRules = function QuotaRules($t) {
  return [{
    label: $t('1632'),
    value: '1'
  },
  // { label: $t('1639'), value: '2' },
  {
    label: $t('1521'),
    value: '3'
  }];
};
// 请假单位
var askLeave = function askLeave($t) {
  return [{
    label: $t('1477'),
    value: '0'
  }, {
    label: $t('1478'),
    value: '1'
  }, {
    label: $t('1479'),
    value: '2'
  }];
};
// 发放天数单位
var askLeave1 = function askLeave1($t) {
  return [$t('1523'), $t('1522'), $t('1522')];
};
// 选择月份和日
var month = function month($t) {
  return Array.from({
    length: 12
  }, function (_, index) {
    return index;
  }).map(function (item) {
    return $t(1538 + item + '');
  });
};
var days = function days($t) {
  return Array.from({
    length: 31
  }, function (_, index) {
    return index;
  }).map(function (item) {
    return $t(1550 + item + '');
  });
};
export default {
  components: {
    Org: Org
  },
  data: function data() {
    var _this = this;
    return {
      isShowConversionRateInput: false,
      tag: '<',
      visible: false,
      disabled: false,
      orgVisible: false,
      dataForm: dedaultDataForm,
      originalDataForm: {},
      // 额度规则
      QuotaRules: QuotaRules(this.$t),
      askLeave: askLeave(this.$t),
      askLeave1: askLeave1(this.$t),
      month: month(this.$t),
      days: days(this.$t),
      // 不带薪
      // 带薪
      // 部分带薪
      ruleList: [{
        key: '0',
        label: this.$t('1665')
      }, {
        key: '1',
        label: this.$t('1669')
      }, {
        key: '2',
        label: this.$t('1670')
      }],
      dataRule: {
        name_en: [{
          required: true,
          message: this.$t('90')
        }],
        days: [{
          validator: function validator(rule, value, callback) {
            value = Number(value);
            if (value === 0) {
              return callback(new Error(_this.$t('1810')));
            }
            if (!value) {
              return callback(new Error(_this.$t('1716')));
            }
            callback();
          },
          trigger: 'blur'
        }],
        time_type: [{
          required: true,
          message: this.$t('90')
        }],
        paid_days: [{
          validator: function validator(rule, value, callback) {
            value = Number(value);
            if (value === 0) {
              return callback(new Error(_this.$t('1673')));
            }
            if (_this.dataForm.is_paid !== null && !value) {
              return callback(new Error(_this.$t('1671')));
            }
            if (value <= 0) {
              return callback(new Error(_this.$t('1673')));
            }
            callback();
          },
          tigger: 'blur'
        }],
        hour_to_day: [{
          required: true,
          message: this.$t('1716'),
          trigger: 'blur'
        }]
      },
      isEdit: false,
      settingCycleArr: []
    };
  },
  computed: {
    maxDay: function maxDay() {
      if (this.dataForm.time_type === '0') return 8784;
      return 366;
    },
    // 额度规则联动发放方式
    CycleArr: function CycleArr() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataForm.rule === '1' ? this.settingCycleArr.slice(0, 2) : this.settingCycleArr.slice(-1);
    },
    GetDays: function GetDays() {
      var dateTime = new Date();
      var year = dateTime.getFullYear();
      var month = this.dataForm.release_month + 1;
      var date = new Date(year, month, 1);
      var days = new Date(date.getTime() - 864e5).getDate();
      var newDays = this.days.slice(0, days);
      return newDays;
    },
    LeaveTip: function LeaveTip() {
      var tips = new Map([
      // 按自然日计算：选中后下方灰色文字提示“请假时段中若包含休息日，也会计入请假天数”；
      ['2', this.$t('leave_tip2')],
      // 按工作日计算：选中后下方灰色文字提示“请假时段默认去除休息日，例如周末、法定节假日”
      ['1', this.$t('leave_tip1')]]);
      return tips.get(this.dataForm.count_rule);
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        this.$refs.dataForm.resetFields();
      }
    }
  },
  methods: {
    // 是否展示假期余额折算规则
    handlerShowRule: function handlerShowRule() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$dataForm, id, time_type, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2$dataForm = _this2.dataForm, id = _this2$dataForm.id, time_type = _this2$dataForm.time_type;
              if (_this2.dataForm.days > _this2.maxDay) _this2.dataForm.days = _this2.maxDay;
              // 编辑状态下才展示
              if (!_this2.isEdit) {
                _context.next = 8;
                break;
              }
              _context.next = 5;
              return showConversionRateInput({
                id: id,
                time_type: time_type
              });
            case 5:
              res = _context.sent;
              _this2.isShowConversionRateInput = res.data;
              return _context.abrupt("return", false);
            case 8:
              _this2.isShowConversionRateInput = time_type === '0';
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 勾选状态变化
    handleIsStaffStatus: function handleIsStaffStatus(val) {
      if (!val) {
        this.dataForm.less_days = 0;
      }
    },
    init: function init(item) {
      var _this3 = this;
      this.dataForm.max_days = this.dataForm.days;
      this.visible = true;
      this.getSettingCycleFn();
      if (item) {
        this.getInfo(item);
        this.isEdit = true;
      } else {
        this.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isEdit = false;
                _this3.originalDataForm = JSON.parse(JSON.stringify(dedaultDataForm));
                _this3.dataForm = JSON.parse(JSON.stringify(dedaultDataForm));
                _this3.$nextTick(function () {
                  return _this3.$refs.dataForm.clearValidate();
                });
                _this3.$nextTick(function () {
                  return (
                    // 是否展示员工假期折算规则
                    _this3.handlerShowRule()
                  );
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })));
      }
    },
    // 打开人员选择
    openEl: function openEl() {
      this.orgVisible = true;
    },
    // 最大天数 不能大于发放天数
    handlerChangeMaxDays: function handlerChangeMaxDays(v) {
      if (Number(this.dataForm.max_days) > Number(v)) this.dataForm.max_days = v;
    },
    // 人员选择回调
    handlerSelected: function handlerSelected(params) {
      this.dataForm.staffs = params.staff_list;
      this.dataForm.deps = params.dept_list;
      this.dataForm.staff_ids = params.staffIds;
      this.dataForm.department_ids = params.depIds;
      this.getSelectNum(params);
    },
    // 回显去重之后的人数
    getSelectNum: function getSelectNum(_ref2) {
      var _this4 = this;
      var _ref2$depIds = _ref2.depIds,
        depIds = _ref2$depIds === void 0 ? [] : _ref2$depIds,
        _ref2$staffIds = _ref2.staffIds,
        staffIds = _ref2$staffIds === void 0 ? [] : _ref2$staffIds;
      countStaffs({
        department_ids: depIds,
        staff_ids: staffIds
      }).then(function (res) {
        _this4.dataForm.num = res.data.staff_num;
        _this4.$forceUpdate();
      });
    },
    // 获取发放时间筛选项
    getSettingCycleFn: function getSettingCycleFn() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getSettingCycleFn();
            case 2:
              res = _context3.sent;
              if (res && res.code === 1) _this5.settingCycleArr = res.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getInfo: function getInfo(item) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, data, staffs;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return ruleInfoListFn({
                id: item.id
              });
            case 2:
              res = _context4.sent;
              if (res && res.code === 1) {
                data = res.data;
                data.my_is_setting = Boolean(Number(data.is_setting));
                data.cycle = Number(data.cycle);
                data.my_release_type = data.release_type === '2';
                data.release_month = 0;
                data.release_day = 0;
                data.release_time = data.release_time || '01-01';
                data.my_incremental_rule = data.incremental_rule || [{
                  get: 0,
                  lt: 1,
                  days: null
                }, {
                  get: 1,
                  lt: null,
                  days: null
                }];
                staffs = [];
                if (Array.isArray(data.staff_ids)) {
                  data.staff_ids.forEach(function (item) {
                    staffs.push({
                      staff_id: item.staff_id,
                      staff_name: item.staff_name,
                      staff_name_en: item.staff_name_en,
                      staff_name_secondary: item.staff_name_secondary,
                      staff_name_th: item.staff_name_th,
                      avatar_url: item.avatar_url
                    });
                    _this6.dataForm.staff_ids.push(item.staff_id);
                  });
                }
                _this6.dataForm = data;
                _this6.originalDataForm = JSON.parse(JSON.stringify(data));
                _this6.handleReleaseTime(data.release_time);
                _this6.dataForm.staffs = staffs;
                _this6.dataForm.deps = _this6.dataForm.department_ids;
                if (Array.isArray(_this6.dataForm.department_ids)) {
                  _this6.dataForm.department_ids = _this6.dataForm.department_ids.map(function (item) {
                    return item.department_id;
                  });
                }
                _this6.$nextTick(function () {
                  return (
                    // 是否展示员工假期折算规则
                    _this6.handlerShowRule()
                  );
                });
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this7 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this7.disabled = true;
          var name_en = _this7.dataForm.name_en;
          if (!_this7.dataForm.name_zh) _this7.dataForm.name_zh = name_en;
          if (!_this7.dataForm.name_th) _this7.dataForm.name_th = name_en;
          _this7.dataFormFn().then(function (res) {
            _this7.disabled = false;
            if (res && res.code === 1) {
              _this7.visible = false;
              _this7.$message.success(res.message || 'success');
              _this7.$emit('getTableList');
            }
          }).catch(function () {
            _this7.disabled = false;
          });
        }
      });
    },
    dataFormFn: function dataFormFn() {
      var staff_ids = this.dataForm.staff_ids.map(function (item) {
        return item.staff_id || item;
      });
      var res = null;
      this.dataForm.max_days = Number(this.dataForm.max_days);
      if (this.dataForm.max_days < Number(this.dataForm.days)) this.dataForm.max_days = Number(this.dataForm.days);
      if (this.isEdit) {
        res = ruleEditFn(_objectSpread(_objectSpread({}, this.dataForm), {}, {
          staff_ids: staff_ids,
          id: this.dataForm.id,
          name: this.dataForm.name,
          days: this.dataForm.days,
          cycle: this.dataForm.cycle
        }));
      } else {
        res = ruleAddFn(_objectSpread(_objectSpread({}, this.dataForm), {}, {
          staff_ids: staff_ids,
          name: this.dataForm.name,
          days: this.dataForm.days,
          is_setting: Number(this.dataForm.my_is_setting) + '',
          release_type: this.dataForm.my_release_type ? '2' : '1',
          incremental_rule: this.dataForm.rule === '1' ? '' : this.dataForm.my_incremental_rule,
          cycle: this.dataForm.cycle
        }));
      }
      return res;
    },
    //  release_time 字段为12-01， 处理数据，单独拿出月日
    handleReleaseTime: function handleReleaseTime(data) {
      var time = data.split('-');
      var month = time[0].replace(/\b(0+)/gi, '');
      var day = time[1].replace(/\b(0+)/gi, '');
      this.dataForm.release_month = Number(month) - 1;
      this.dataForm.release_day = Number(day) - 1;
    },
    // 发放时间切换，里面内容默认初始数据
    handleCycle: function handleCycle(item) {
      // (item/data.cycle) typeof 为number
      var data = this.dataForm;
      var original = this.originalDataForm; // 深度拷贝的初始数据(未修改的数据)
      data.my_release_type = null;
      data.expire_time = '1';
      data.is_hire = original.is_hire;
      data.rule = original.rule;
      if (item === 3) {
        // item == (data.cycle == 3)时，为仅发放一次， release_time要默认为01-01，为禁止选择状态
        data.release_time = '01-01';
        data.release_month = 0;
        data.release_day = 0;
        data.expire_time = '2';
        data.rule = '1';
      } else {
        data.release_time = original.release_time;
        this.handleReleaseTime(original.release_time);
      }
      if (item === 4) {
        // item == (data.cycle == 4)时，为额度满0.5天时发放一次， rule === 2 为司龄+ 自然年
        data.rule = '2';
      }
    },
    // 处理发放时间月份
    handleReleaseMont: function handleReleaseMont(item) {
      this.dataForm.release_month = item;
      var month = this.dataForm.release_month + 1;
      var day = this.dataForm.release_day + 1;
      var release_time = "".concat(month < 10 ? 0 : '').concat(month, "-").concat(day < 10 ? 0 : '').concat(day);
      this.dataForm.release_time = release_time;
    },
    // 处理发放时间日期
    handleReleaseDay: function handleReleaseDay(item) {
      this.dataForm.release_day = item;
      var month = this.dataForm.release_month + 1;
      var day = this.dataForm.release_day + 1;
      var release_time = "".concat(month < 10 ? 0 : '').concat(month, "-").concat(day < 10 ? 0 : '').concat(day);
      this.dataForm.release_time = release_time;
    },
    // 司龄递增除第一个和最后一个以外
    reviseIncrementalRule: function reviseIncrementalRule(type, item, ind) {
      var incremental = this.dataForm.my_incremental_rule;
      var len = incremental.length;
      // 当前操作的上一个
      var prev = incremental[ind - 1];
      // 当前操作的下一个
      var next = incremental[ind + 1];
      if (len > 2) {
        if (type === 'last') {
          // 如果修改的是最后一个，将前一个的lt与最后一个get相等
          prev.lt = item.get;
        } else {
          // 除最后一个以外，上一个的get与当前lt相等
          next.get = item.lt;
        }
      } else {
        next ? next.get = item.lt : prev.lt = item.get;
      }
    },
    // 添加司龄递增规则
    addIncrementalRule: function addIncrementalRule() {
      var incremental = this.dataForm.my_incremental_rule;
      var len = incremental.length;
      // 获取最后一个值
      var last = incremental[len - 1];
      // 获取倒数第二个值
      var last2 = incremental[len - 2];
      var status = last.get === last2.lt;
      var data = [{
        get: last2.lt,
        lt: len <= 2 && !status ? last.get : last.get + 1,
        // 只有两条数据的话，当前只有两条数据且最后一条数据get不为1的情况下+1，否则相等
        days: ''
      }, {
        get: len <= 2 && !status ? last.get : last.get + 1,
        // 同上
        lt: null,
        days: ''
      }];
      incremental.splice.apply(incremental, [len - 1, 1].concat(data));
    },
    // 删除司龄递增规则
    deleteIncrementalRule: function deleteIncrementalRule(item, index) {
      var incremental = this.dataForm.my_incremental_rule;
      var len = incremental.length;
      var prev = incremental[index - 1];
      var next = incremental[index + 1];
      if (len > 3) {
        if (index === len - 2) {
          // 删除的是倒数第二个数据，要将上一个的lt与最后一个的get相等
          prev.lt = incremental[len - 1].get;
        } else {
          // 不是倒数第二条数据，可以直接将当前数据的上一条数据get与当前数据下一条lt相等
          next.get = prev.lt;
        }
      } else {
        prev.lt = next.get;
      }
      incremental.splice(index, 1);
    },
    incrementalMax: function incrementalMax(index) {
      var next = this.dataForm.my_incremental_rule[index + 1];
      var max = next && next.lt ? next.lt - 1 : Infinity;
      return max;
    }
  }
};